export default __webpack_public_path__ + "static/media/table_document_back.50b5fad2.png";